import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../Request";
import requestMiddlewares from "../../requestMiddlewares";

export interface IGetAdsDisplayRequest {
  vertical?: number;
  horizontal?: number;
}

export default async function getAdsDisplayRequest(
  dispatch: Dispatch,
  input: IGetAdsDisplayRequest,
): Promise<IResponse> {
  const request = new RACARequest('ads', 'display')
    .setQueryParameters(input);

  const response = await request.makeRequest();
  requestMiddlewares(
    dispatch,
    response,
  );

  return response;
}
